export default __webpack_public_path__ + "static/media/settingsBlue.7ed95f53.svg";